import TaxGuideLeadMagnet from './TaxGuideLeadMagnet.svelte';
import './index.css';
import { Country } from './countries';

Array.from(document.getElementsByClassName("lead-magnet-inline")).forEach(app => {
  const country = app.dataset.country ?? Country.UnitedStates;
  new TaxGuideLeadMagnet({
    target: app,
    props: { country }
  });
});
